import { type TNavigationOptions, updateSearchParams } from '@/ducks/routes/history';

const removeSearchParamsNative = (params: string[], options?: TNavigationOptions) => {
  updateSearchParams({
    ...options,
    searchParamsUpdater: (searchParams: URLSearchParams) => {
      params.forEach((key) => {
        if (searchParams.has(key)) searchParams.delete(key);
      });
    },
  });
};

export default removeSearchParamsNative;
